import Tooltip from "../UI/TooltipIcon/TooptipIcon";
import React,{useState} from "react";
import { Alert,Popover,PopoverBody,PopoverHeader } from "reactstrap";

export default function  ChartInfoPopover (
{chartId}
) {
    const [openChartInfo,setOpenChartInfo] = useState(false)
    return (
      <span>
        <span
          id={`chart-status-popover_${chartId}`}
          className=""
          onClick={()=>setOpenChartInfo(!openChartInfo)}
        >
          <Tooltip customHeight={"12px"} customWidth={"12px"} customMarginLeft="2px" />
        </span>
        <Popover
          placement="right"
          isOpen={openChartInfo}
          target={`chart-status-popover_${chartId}`}
          toggle={()=>setOpenChartInfo(!openChartInfo)}
        >
          <PopoverHeader className="popover-header-tooltip">
            Chart Status
          </PopoverHeader>
          <PopoverBody className="popover-body-tooltip">
            <span className="fw600">Active</span> means this chart can be
            updated as new data is uploaded to the system and/or as hierarchy
            changes are made in your organization. <br />
            <br /> <span className="fw600">Locked</span> means this chart’s data
            will no longer updated by new data or hierarchy changes.
          </PopoverBody>
        </Popover>
      </span>
    );
  };